export default 'PaymentGroupsPage';
